document.addEventListener("DOMContentLoaded", function () {

    const isHomePage = window.isHomePage;

    const ball = document.getElementById("football-launch-ball");
    const desktopIcon =
document.getElementById("footballHeaderButton");

const mobileIcon =
document.getElementById("footballHeaderButtonMobile");

let headerIcon =
window.innerWidth <= 768
    ? mobileIcon
    : desktopIcon;

    // Show football and start idle bounce immediately
if (desktopIcon) {
    desktopIcon.classList.add("show");
    desktopIcon.classList.add("idle");
}

if (mobileIcon) {
    mobileIcon.classList.add("show");
    mobileIcon.classList.add("idle");
}

    /*-----------------------------------
If animation already played
------------------------------------*/
 /*
if(sessionStorage.getItem("footballPlayed")){

    if(desktopIcon)
        desktopIcon.classList.add("show");

    if(mobileIcon)
        mobileIcon.classList.add("show");

    if(ball)
        ball.style.display="none";

    return;
}
*/
   


// ==========================
// WAIT FOR 700PX SCROLL
// ==========================

if (!headerIcon) return;
if (!ball) return;

// Hide the football initially
ball.style.display = "none";

if (isHomePage) {

    let animationStarted = false;

    window.addEventListener("scroll", function () {

        if (animationStarted) return;

        if (window.scrollY >= 700) {

            animationStarted = true;
            startAnimation();

        }

    });

} else {

      // Internal pages:
    // Hide the big animated ball only.
    // Small football is already shown and bouncing from Step 1.

    ball.style.display = "none";

    return;

}

    // Initial state
    function startAnimation() {
    ball.style.display = "block";
    ball.style.opacity = "0";
    ball.style.left = "42%";
    ball.style.top = "44%";
    ball.style.transform = "translate(-50%, -50%) scale(.2) rotate(0deg)";

    // ==========================
    // POP IN
    // ==========================
    setTimeout(() => {

        ball.style.transition =
            "transform 1s cubic-bezier(.22,.61,.36,1), opacity .4s ease, filter .8s ease";

        ball.style.opacity = "1";

        ball.style.filter =
            "drop-shadow(0 35px 40px rgba(0,0,0,.30))";

        // Overshoot slightly
        ball.style.transform =
            "translate(-50%, -50%) scale(1.15) rotate(720deg)";

    }, 300);

    // ==========================
    // SETTLE BEFORE FLIGHT
    // ==========================
    setTimeout(() => {

        ball.style.transition =
            "transform .35s ease";

        ball.style.transform =
            "translate(-50%, -50%) scale(1) rotate(760deg)";

    }, 1400);

    // ==========================
    // FLY TO HEADER
    // ==========================
    setTimeout(() => {

        const rect = headerIcon.getBoundingClientRect();

        ball.style.transition =
            "left 1.1s cubic-bezier(.25,.8,.25,1), top 1.1s cubic-bezier(.25,.8,.25,1), transform 1.1s ease";

        // Move to header
        ball.style.left = rect.left + rect.width / 2 + "px";
        ball.style.top = rect.top + rect.height / 2 + "px";

        // Shrink while spinning
        ball.style.transform =
            "translate(-50%, -50%) scale(.18) rotate(1260deg)";

    }, 1800);

    // ==========================
    // LANDING BOUNCE
    // ==========================
    setTimeout(() => {

        ball.style.transform =
            "translate(-50%, -50%) scale(.23) rotate(1280deg)";

    }, 2850);

    setTimeout(() => {

        ball.style.transform =
            "translate(-50%, -50%) scale(.18) rotate(1290deg)";

    }, 3000);

    // ==========================
    // SHOW HEADER ICON
    // ==========================
    setTimeout(() => {

    ball.style.transition += ", opacity .35s ease";
   
    ball.style.opacity = "0";

    if (desktopIcon) {
        desktopIcon.classList.add("landing");

setTimeout(() => {
      desktopIcon.classList.remove("landing");
}, 1200);
    }

    if (mobileIcon) {
        mobileIcon.classList.add("landing");

        setTimeout(() => {
             mobileIcon.classList.remove("landing");
        }, 1200);
    }

}, 3150);

} // End startAnimation()

});